import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { toPairs } from "../../core";
import { ErrorBox, SelectFieldControler, TextFieldControler } from "../../form";
import { CheckboxFieldControler } from "../../form/CheckboxFieldControler";
import { DateFieldControler } from "../../form/DateFieldControler";
import { RadioFieldControler } from "../../form/RadioFieldControler";
import { UserNote, } from "../../ordering";
import { StreetAddressFormController } from "./StreetAddressFormController";
export class OnlineFulfillmentFormControler {
    constructor(params) {
        var _a, _b, _c, _d;
        this.type = "Online";
        this.userNoteMaxLength = UserNote.MAX_LENGTH;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.fulfillmentTime = params.fulfillmentTime;
        this.streetAddress =
            params.fulfillmentInstructions.deliveryAddress.streetAddress;
        this.apartmentInfo =
            params.fulfillmentInstructions.deliveryAddress.apartmentInfo;
        this.isPostCodeRequired = this.streetAddress.isPostCodeRequired;
        this.isNoContactDelivery =
            params.fulfillmentInstructions.fulfillmentMethodType ===
                "NoContactDelivery";
        this.streetAddressController = new StreetAddressFormController({
            streetAddress: this.streetAddress,
            geocodingService: params.geocodingService,
            geolocationService: params.geolocationService,
        });
        this.apartmentInfoFields =
            this.apartmentInfo.type === "Romanian"
                ? {
                    type: "Romanian",
                    fields: {
                        sector: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.sector,
                            update: (value) => this.setRomanianAptData({ sector: value }),
                        }),
                        houseOrBlock: new SelectFieldControler({
                            initialValue: this.apartmentInfo.data.houseOrBlock,
                            update: (value) => this.setRomanianAptData({ houseOrBlock: value }),
                        }),
                        block: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.block,
                            update: (value) => this.setRomanianAptData({ block: value }),
                            errorBox: new ErrorBox({
                                domainObjects: [this.fulfillmentInstructions],
                                errorMessages: {
                                    BlockMissing: I18n.t("_common.form.errors.required"),
                                },
                            }),
                        }),
                        staircase: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.staircase,
                            update: (value) => this.setRomanianAptData({ staircase: value }),
                            errorBox: new ErrorBox({
                                domainObjects: [this.fulfillmentInstructions],
                                errorMessages: {
                                    StaircaseMissing: I18n.t("_common.form.errors.required"),
                                },
                            }),
                        }),
                        floor: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.floor,
                            update: (value) => this.setRomanianAptData({ floor: value }),
                            errorBox: new ErrorBox({
                                domainObjects: [this.fulfillmentInstructions],
                                errorMessages: {
                                    FloorMissing: I18n.t("_common.form.errors.required"),
                                },
                            }),
                        }),
                        aptNumber: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.aptNumber,
                            update: (value) => this.setRomanianAptData({ aptNumber: value }),
                            errorBox: new ErrorBox({
                                domainObjects: [this.fulfillmentInstructions],
                                errorMessages: {
                                    AptNumberMissing: I18n.t("_common.form.errors.required"),
                                },
                            }),
                        }),
                        interphone: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.interphone,
                            update: (value) => this.setRomanianAptData({ interphone: value }),
                        }),
                        additionalInfo: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.additionalInfo,
                            update: (value) => this.setRomanianAptData({ additionalInfo: value }),
                        }),
                    },
                }
                : {
                    type: "Default",
                    fields: {
                        aptNumber: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.aptNumber,
                            update: (value) => this.setDefaultAptData({ aptNumber: value }),
                        }),
                        floor: new TextFieldControler({
                            initialValue: this.apartmentInfo.data.floor,
                            update: (value) => this.setDefaultAptData({ floor: value }),
                        }),
                    },
                };
        this.noContactDeliveryController = new CheckboxFieldControler({
            initialValue: this.isNoContactDelivery,
            update: (value) => {
                this.isNoContactDelivery = value;
                this.fulfillmentInstructions.fulfillmentMethodType = value
                    ? "NoContactDelivery"
                    : "Delivery";
            },
        });
        this.fulfillmentMethodControler = new RadioFieldControler({
            initialValue: this.fulfillmentInstructions.fulfillmentMethodType ===
                "NoContactDelivery"
                ? "Delivery"
                : this.fulfillmentInstructions.fulfillmentMethodType,
            update: (value) => {
                this.fulfillmentInstructions.fulfillmentMethodType =
                    value === "Delivery" && this.isNoContactDelivery
                        ? "NoContactDelivery"
                        : value;
            },
            options: ["DineIn", "Delivery", "Takeaway"],
        });
        this.fulfillmentTimeHourControler = new SelectFieldControler({
            initialValue: (_a = this.fulfillmentTime.hourValue) !== null && _a !== void 0 ? _a : "",
            update: (value) => this.fulfillmentTime.setHour(value),
        });
        this.fulfillmentTimeDateControler = new DateFieldControler({
            initialValue: (_b = this.fulfillmentTime.dateValue) !== null && _b !== void 0 ? _b : "",
            update: (value) => this.fulfillmentTime.setDate(value, this.fulfillmentTimeHourControler),
            errorBox: new ErrorBox({
                domainObjects: [this.fulfillmentInstructions],
                errorMessages: {
                    InvalidDate: I18n.t("_common.form.errors.invalid"),
                    // TODO: error message if selected date if out of start-end range
                    // DateOutOfRange: "Date out of range",
                },
            }),
        });
        this.fulfillmentTimeController = new RadioFieldControler({
            initialValue: this.fulfillmentTime.optionValue,
            update: (value) => {
                this.fulfillmentTime.setOption(value, this.fulfillmentTimeDateControler, this.fulfillmentTimeHourControler);
            },
            options: ["ASAP", "Today", "InFuture"],
        });
        this.userNoteController = new TextFieldControler({
            initialValue: (_d = (_c = this.fulfillmentInstructions.userNote) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "",
            update: (value) => {
                this.fulfillmentInstructions.userNote = new UserNote({ value });
            },
            errorBox: new ErrorBox({
                domainObjects: [this.fulfillmentInstructions],
                errorMessages: {
                    MaxLengthExceeded: I18n.t("orders.checkout.max_length", {
                        l: this.userNoteMaxLength,
                    }),
                },
            }),
        });
        makeAutoObservable(this);
    }
    setRomanianAptData(data) {
        if (this.apartmentInfo.type === "Romanian") {
            this.apartmentInfo.setData(data);
        }
    }
    setDefaultAptData(data) {
        if (this.apartmentInfo.type === "Default") {
            this.apartmentInfo.setData(data);
        }
    }
    get streetAddressFields() {
        return this.streetAddressController.fields;
    }
    async locateMe() {
        const streetAddress = await this.fulfillmentInstructions.deliveryAddress.locateMe();
        // TODO: what if user geolocation is not available? maybe we would like to display some error message?
        if (streetAddress !== null) {
            this.streetAddressFields.city.onChange(streetAddress.city);
            this.streetAddressFields.street.onChange(streetAddress.street);
            this.streetAddressFields.streetNumber.onChange(streetAddress.streetNumber);
        }
    }
    // FIXME: mark all form fields as touched
    touch() {
        this.streetAddressController.touch();
        // toPairs(this.apartmentInfoFields.fields).forEach(([_, field]) =>
        //   field.onBlur()
        // );
        toPairs(this.fields).forEach(([_, field]) => {
            if ("onBlur" in field)
                field.onBlur();
        });
    }
    get fields() {
        return {
            fulfillmentMethod: this.fulfillmentMethodControler,
            noContactDelivery: this.noContactDeliveryController,
            streetAddress: this.streetAddressFields,
            apartmentInfo: this.apartmentInfoFields,
            fulfillmentTime: this.fulfillmentTimeController,
            fulfillmentTimeHour: this.fulfillmentTimeHourControler,
            fulfillmentTimeDate: this.fulfillmentTimeDateControler,
            userNote: this.userNoteController,
        };
    }
}
